var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#006699"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48893 5.51999C5.95398 5.51999 5.52002 5.94074 5.52002 6.4591V17.6912C5.52002 18.2096 5.95403 18.63 6.48893 18.63H17.6611C18.1963 18.63 18.63 18.2095 18.63 17.691V6.4591C18.63 5.94074 18.1963 5.51999 17.6611 5.51999H6.48893ZM9.50392 10.5892V16.4914H7.54213V10.5892H9.50392ZM9.63322 8.76389C9.63322 9.33028 9.20741 9.7835 8.52343 9.7835L8.51058 9.78345C7.85216 9.78345 7.42649 9.33023 7.42649 8.76384C7.42649 8.18459 7.86501 7.74402 8.53644 7.74402C9.20741 7.74402 9.62042 8.18459 9.63322 8.76389ZM12.5514 16.4914H10.5898C10.5898 16.4914 10.6155 11.1431 10.5899 10.5894H12.5516V11.4248C12.8124 11.0227 13.2791 10.4508 14.3196 10.4508C15.6103 10.4508 16.578 11.2944 16.578 13.1072V16.4914H14.6164V13.3342C14.6164 12.5407 14.3323 11.9995 13.6227 11.9995C13.0806 11.9995 12.7578 12.3645 12.6161 12.7171C12.5642 12.8429 12.5514 13.0195 12.5514 13.1957V16.4914Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.da38ab6078cb7892a41f2a95d13ab7b4.svg";
export { ForwardRef as ReactComponent };